module.exports = __webpack_public_path__ + "static/media/about-adsticker-ko@2x.96a65bd1.png";